import { Component, OnInit } from '@angular/core';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { SettingsSubscriptionsComponent } from '../settings-subscriptions/settings-subscriptions.component';
import { NgIf, CurrencyPipe } from '@angular/common';

@Component({
    selector: 'app-change-subscription-page',
    templateUrl: './change-subscription-page.component.html',
    styleUrls: ['./change-subscription-page.component.css'],
    imports: [NgIf, NgbAlert, SettingsSubscriptionsComponent, CurrencyPipe]
})
export class ChangeSubscriptionPageComponent implements OnInit {

  showCardAlert: boolean = false;
  login = JSON.parse(localStorage.getItem("login"));

  ngOnInit(): void {
    if( !this.login?.isWithCardOnFile && this.login?.role === "SUPER" && this.login?.monthDelinquent > 1){
      this.showCardAlert = true;
    }
  }
}
